// @module eComm.SegmentationExtension.SegmentationExtension
define('Footer.Segmentation.View'
,	[
		'Footer.View'
	,   'SC.Configuration'
	,	'Utils'
	,	'jQuery'
	,	'underscore'
	]
,	function FooterSegmentationView(
		FooterView
	,   Configuration
	,	Utils
	,	jQuery
	,	_
	)
{
	'use strict';
	console.log('Footer Segmentation View Loaded');

	var getColLinks = function getColLinks(whichColumn, isB2B) {
		console.log('getColLinks passed op1',isB2B);
		console.log('getColLinks passed op2',whichColumn);
        // for large format footer with up to four columns of links
		var multiColLinks = Configuration.get('footer.multiColLinks', []);
        var targetColLinks = jQuery.grep(multiColLinks, function targetColLinks(e) {
			if(isB2B){
				console.log('getColLinks: isB2B');
				return e.column === whichColumn && (e.segmentation === 'Both' || e.segmentation === 'B2B');
			}
			console.log('getColLinks: isB2C');
			return e.column === whichColumn && (e.segmentation === 'Both' || e.segmentation === 'B2C');
        });
        return targetColLinks;
    };

	// @class eComm.SegmentationExtension.SegmentationExtension.View @extends Backbone.View
	return {
		loadModule: function loadModule(container) {
			// var Layout = this.container.getComponent("Layout");
			var isB2B = false;
			var layout = container.getComponent('Layout')
			console.log('return: isB2B');
			
			var userProfileComponent = container.getComponent('UserProfile');

			// _.defer(function() {
				userProfileComponent.getUserProfile().then(function(profile) {
					// console.log('footer profile', profile);
					isB2B = profile.isloggedin ? _.findWhere(profile.customfields, {id: 'custentity_ano_is_b2b'}).value:false;
					// console.log('isB2B footer',isB2B);
	
					var socialMediaLinks = Configuration.get('footer.socialMediaLinks', []);
					// for Copyright message
					var initialConfigYear = Configuration.get('footer.copyright.initialYear');
					var initialYear = initialConfigYear ? parseInt(initialConfigYear, 10) : new Date().getFullYear();
					var currentYear = new Date().getFullYear();
					console.log('isB2B', isB2B);
					console.log('profile', profile);
					layout.removeToViewContextDefinition('Footer.View', 'extraFooterView');
					layout.addToViewContextDefinition(
						'Footer.View',
						'extraFooterView',
						'object',
						function (con) {
							console.log('con', con);
							return _.extend(con, {
								// @property {Array<Object>} col1Links
								col1Links: getColLinks('Column 1', isB2B),
								// @property {Array<Object>} col2Links
								col2Links: getColLinks('Column 2', isB2B),
								// @property {Array<Object>} col3Links
								col3Links: getColLinks('Column 3', isB2B),
								// @property {Array<Object>} col4Links
								col4Links: getColLinks('Column 4', isB2B),
								// @property {Array<Object>} socialMediaLinks
								socialMediaLinks: socialMediaLinks,
								copyright: {
									hide: !!Configuration.get('footer.copyright.hide'),
									companyName: Configuration.get('footer.copyright.companyName'),
									initialYear: initialYear,
									currentYear: currentYear,
									showRange: initialYear < currentYear
								},
								text: Configuration.get('footer.text'),
								// @property {String} logoUrl
								logoUrl: Utils.getAbsoluteUrlOfNonManagedResources(Configuration.get('header.logoUrl')),
								showLegacyNewsletter: Configuration.get('footer.showLegacyNewsletter')
							});
						});
	
					
					// FooterView.addExtraContextProperty(
					// 	'extraFooterView',
					// 	'object',
					// 	function FooterViewAddExtraContextProperty() {
					// 		return {
					// 			// @property {Array<Object>} col1Links
					// 			col1Links: getColLinks('Column 1', isB2B),
					// 			// @property {Array<Object>} col2Links
					// 			col2Links: getColLinks('Column 2', isB2B),
					// 			// @property {Array<Object>} col3Links
					// 			col3Links: getColLinks('Column 3', isB2B),
					// 			// @property {Array<Object>} col4Links
					// 			col4Links: getColLinks('Column 4', isB2B),
					// 			// @property {Array<Object>} socialMediaLinks
					// 			socialMediaLinks: socialMediaLinks,
					// 			copyright: {
					// 				hide: !!Configuration.get('footer.copyright.hide'),
					// 				companyName: Configuration.get('footer.copyright.companyName'),
					// 				initialYear: initialYear,
					// 				currentYear: currentYear,
					// 				showRange: initialYear < currentYear
					// 			},
					// 			text: Configuration.get('footer.text'),
					// 			// @property {String} logoUrl
					// 			logoUrl: Utils.getAbsoluteUrlOfNonManagedResources(Configuration.get('header.logoUrl'))
					// 		}
					// 	}
					// );
				});

			// });
			
        }
	}
});
